// app/middleware/notFoundAmericas.ts

export default defineNuxtRouteMiddleware((from, to) => {
  if (to.params.region === "mena") {
    throw createError({ statusCode: 404 });
  }
});
